import { render, staticRenderFns } from "./CardSettings.vue?vue&type=template&id=2fc6ec79&scoped=true"
import script from "./CardSettings.vue?vue&type=script&lang=ts"
export * from "./CardSettings.vue?vue&type=script&lang=ts"
import style0 from "./CardSettings.vue?vue&type=style&index=0&id=2fc6ec79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc6ec79",
  null
  
)

export default component.exports